import axios from "axios";
import firebase from "firebase/app";

import * as constants from "../../constants";

const PostItem = (path, item) => {
	return new Promise((resolve, reject) => {
		if (firebase.auth().currentUser) {
			firebase
				.auth()
				.currentUser.getIdToken(true)
				.then(token => {
					var api = axios.create({
						baseURL: constants.BASE_API_URL,
						timeout: 20000,
						headers: { Authorization: "Bearer " + token },
					});
					api.post(path, item)
						.then(res => {
							resolve(res);
						})
						.catch(error => {
							reject(error);
						});
				});
		} else {
			reject("Unauthorized");
		}
	});
};

export default PostItem;
